import '@babel/polyfill'
import Vue 			from 'vue'
import VueRouter 	from 'vue-router'
import VueResource 	from 'vue-resource'
import VeeValidate from 'vee-validate';
import VueNotify	from 'vue2-notify'
import Vuex from 'vuex'
import moment from 'moment'
import store 	from './store'

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueNotify, {
	position: 'top-right' 
})

var routes = [
	{
	  path: '/login',
	  component: require('./layouts/LoginDashView')
	},
	{
	  path: '/',
	  component: require('./layouts/DashView'),
    meta: { auth: true },
	  children: [
	    {
	    	// Pages d'accueil (politiques)
	      path: 'horaires',
				name: 'Horaires',
				component: require('./pages/Horaires'),
	      alias: '/',
	    },
	    {
	      path: 'horaires/ajouter',
				name: 'Horaires.ajouter',
				component: require('./pages/HorairesEdit'),
	    },
	    {
	      path: 'horaires/:id',
				name: 'Horaires.modifier',
				component: require('./pages/HorairesEdit'),
	    },
	    {
	      path: 'types',
				name: 'TypesCollectes',
				component: require('./pages/TypesCollectes'),
	    },
	    {
	      path: 'ecocentres',
				name: 'Ecocentres',
				component: require('./pages/Ecocentres'),
	    },
	    {
	      path: 'mot-passe',
				name: 'MotPasse',
				component: require('./pages/MotPasseEdit'),
	    },
	    {
	      path: 'recherche',
				name: 'Recherche',
				component: require('./pages/Recherche'),
	    }
	  ],
	}
];

Vue.use({install(Vue, options) {
  Vue.prototype.$storage = function (path) {
    return process.env.API_URL + 'storage/' + path;
  }
}});

Vue.router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_DIR,
  routes: routes
})

// Plugin parameters
moment.locale('fr');

// Create Vue instance with options and I18n
var component = require('./layouts/App.vue');
component.router = Vue.router;
component.store = store;

// Formulaires validation
Vue.use(VeeValidate, {
	locale: 'fr',
  dictionary: {
    fr: require('./strings/validator/messages/fr.js').default
  }
});

// Http 
var API_URL = process.env.API_URL + 'server/api/';
Vue.http.options.root = API_URL;
Vue.http.headers.common['accept'] = 'application/json';

// Vue Auth
Vue.use(require('@websanova/vue-auth'), {
  auth: require('./auth.js'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {url: API_URL + 'auth/login', method: 'POST', redirect: '/', fetchUser: true},
  refreshData: {url: API_URL + 'auth/refresh', method: 'POST', enabled: false, interval: 30},
  fetchData: {url: 'auth/me', method: 'GET', enabled: true},
  authRedirect: { path: '/login' },
  rolesVar: "scopes"
});

new Vue(component).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js